import React from 'react';

function Box3d50(props) {
	return (
		<svg height="30" width="30" viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg">
	<g fill="#000">
		<path d="M6.36 5.02l-5.12 3.08 15.14 8.81 5.07-3.04z" fill="#000"/>
		<path d="M22.68 13.13l6.3-3.78-14.8-8.63a0.63 0.63 0 0 0-0.64 0l-5.95 3.57 15.09 8.84z" fill="#000"/>
		<path d="M17.01 18v11.31l12.33-8.63a0.63 0.63 0 0 0 0.27-0.52v-9.72l-12.6 7.56z" fill="#000"/>
		<path d="M15.75 18l-15.12-8.8v10.96c0 0.22 0.12 0.43 0.31 0.54l14.81 8.64v-11.34z" fill="#000"/>
	</g>
</svg>
	);
};

export default Box3d50;